import { render, staticRenderFns } from "./ResidentFeedbackTable.vue?vue&type=template&id=ea62b718&"
import script from "./ResidentFeedbackTable.vue?vue&type=script&lang=js&"
export * from "./ResidentFeedbackTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports